import React from "react";
import PropTypes from "prop-types";
import Menu, { MenuItem } from "material-ui/Menu";
import Divider from "material-ui/Divider";
import { ListItem, ListItemText } from "material-ui/List";
import { withStyles } from "material-ui/styles";

const styles = theme => ({
  root: {
    flexShrink: 0
  }
});

class AnchoredMenu extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      anchorEl: null
    };

    this.handleOpen = this.handleOpen.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }

  handleOpen(event) {
    this.setState({ anchorEl: event.currentTarget });
  }

  handleClose() {
    this.setState({ anchorEl: null });
  }

  handleSelect(value) {
    this.props.onSelect(value);
    this.setState({ anchorEl: null });
  }

  renderItems() {
    return this.props.items.map((b, i) => {
      if (b.label !== "DIVIDER") {
        return (
          <MenuItem dense key={i} onClick={() => this.handleSelect(b.value)}>
            {b.label}
          </MenuItem>
        );
      } else {
        return <Divider key={i} />;
      }
    });
  }

  renderSecondary(text) {
    return <div> {text} </div>;
  }

  render() {
    return (
      <div className={this.props.classes.root}>
        <ListItem component="div" dense button onClick={this.handleOpen}>
          <ListItemText
            primary={this.props.primary}
            secondary={this.props.secondary}
          />
        </ListItem>

        <Menu
          open={Boolean(this.state.anchorEl)}
          anchorEl={this.state.anchorEl}
          onClose={this.handleClose}
        >
          {this.renderItems()}
        </Menu>
      </div>
    );
  }
}

AnchoredMenu.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string
    })
  ),
  onSelect: PropTypes.func.isRequired,
  primary: PropTypes.string.isRequired,
  secondary: PropTypes.string.isRequired
};

AnchoredMenu.defaultProps = {
  items: []
};

export { AnchoredMenu };

export default withStyles(styles, { name: "AnchoredMenu" })(AnchoredMenu);



// WEBPACK FOOTER //
// ./src/AnchoredMenu.js